var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "tr",
    { staticClass: "component-tr", class: { "has-error": !_vm.is_loaded } },
    [
      _c("td", { staticClass: "name-column" }, [
        _vm._v(_vm._s(_vm.se_component.name))
      ]),
      _vm._v(" "),
      _c(
        "td",
        {
          class: {
            "quantity-column": true,
            "has-error": _vm.has_quantity_error,
            "compare-base-value":
              _vm.se_component.compare_base &&
              _vm.se_component.quantity !==
                _vm.se_component.compare_base.quantity
          }
        },
        [
          _vm.quantity_configurable
            ? _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.quantity,
                      expression: "quantity"
                    }
                  ],
                  staticClass: "quantity-column-select",
                  class: { "has-error": _vm.has_quantity_error },
                  on: {
                    wheel: _vm.quantity_select_wheel_event,
                    change: function($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function(o) {
                          return o.selected
                        })
                        .map(function(o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.quantity = $event.target.multiple
                        ? $$selectedVal
                        : $$selectedVal[0]
                    }
                  }
                },
                [
                  !_vm.valid_quantities.includes(_vm.quantity)
                    ? _c("option", [_vm._v(_vm._s(_vm.quantity))])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm._l(_vm.valid_quantities, function(valid_quantity) {
                    return _c(
                      "option",
                      {
                        key: valid_quantity,
                        class: {
                          "compare-base-value":
                            _vm.se_component.compare_base &&
                            valid_quantity ===
                              _vm.se_component.compare_base.quantity
                        }
                      },
                      [
                        _vm._v(
                          "\n\t\t\t\t" + _vm._s(valid_quantity) + "\n\t\t\t"
                        )
                      ]
                    )
                  })
                ],
                2
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.quantity_configurable
            ? _c("span", [_vm._v(_vm._s(_vm.quantity_pretty))])
            : _vm._e()
        ]
      ),
      _vm._v(" "),
      _c(
        "td",
        {
          class: {
            "part-column": true,
            "compare-base-value":
              _vm.se_component.compare_base &&
              _vm.se_component.part !== _vm.se_component.compare_base.part
          }
        },
        [
          _c(
            "select",
            {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.part,
                  expression: "part"
                }
              ],
              staticClass: "part-column-select",
              on: {
                change: function($event) {
                  var $$selectedVal = Array.prototype.filter
                    .call($event.target.options, function(o) {
                      return o.selected
                    })
                    .map(function(o) {
                      var val = "_value" in o ? o._value : o.value
                      return val
                    })
                  _vm.part = $event.target.multiple
                    ? $$selectedVal
                    : $$selectedVal[0]
                }
              }
            },
            [
              _vm._l(_vm.valid_parts, function(part_value) {
                return _c(
                  "option",
                  {
                    key: part_value["Name"],
                    class: {
                      "compare-base-value":
                        _vm.se_component.compare_base &&
                        part_value["Name"] ===
                          _vm.se_component.compare_base.part
                    }
                  },
                  [
                    _vm._v(
                      "\n\t\t\t\t" + _vm._s(part_value["Name"]) + "\n\t\t\t"
                    )
                  ]
                )
              }),
              _vm._v(" "),
              !_vm.is_valid_part
                ? _c("option", { staticClass: "has-error" }, [
                    _vm._v(_vm._s(_vm.part))
                  ])
                : _vm._e()
            ],
            2
          )
        ]
      ),
      _vm._v(" "),
      _vm._l(_vm.stats.names, function(name) {
        return [
          _c("StatlineCell", {
            key: name,
            attrs: { stats: _vm.stats, name: name }
          })
        ]
      }),
      _vm._v(" "),
      _c("td", { staticClass: "weight-internal-column" }, [
        _vm._v(_vm._s(_vm.weight_internal))
      ]),
      _vm._v(" "),
      _c("td", { staticClass: "weight-external-column" }, [
        _vm._v(_vm._s(_vm.weight_external))
      ]),
      _vm._v(" "),
      _c("td", { staticClass: "br-column" }, [_vm._v(_vm._s(_vm.cost_BR))]),
      _vm._v(" "),
      _c("td", { staticClass: "sr-column" }, [_vm._v(_vm._s(_vm.cost_SR))]),
      _vm._v(" "),
      _vm.se_component.refit_valid
        ? [
            _c("td", { staticClass: "br-column" }, [
              _vm._v(_vm._s(_vm.refit_cost_BR))
            ]),
            _vm._v(" "),
            _c("td", { staticClass: "sr-column" }, [
              _vm._v(_vm._s(_vm.refit_cost_SR))
            ])
          ]
        : _vm._e(),
      _vm._v(" "),
      _c("td", { staticClass: "power-cost-column" }, [
        _vm._v(_vm._s(_vm.power_cost))
      ]),
      _vm._v(" "),
      _c("td", { staticClass: "power-gen-column" }, [
        _vm._v(_vm._s(_vm.power_gen))
      ]),
      _vm._v(" "),
      _vm._l(_vm.crew.names, function(name) {
        return [
          _c("StatlineCell", {
            key: name,
            attrs: { stats: _vm.crew, name: name }
          })
        ]
      }),
      _vm._v(" "),
      _c("td", { staticClass: "build-time-column" }),
      _vm._v(" "),
      _c(
        "td",
        {
          staticClass: "tech-year-column",
          class: ((_obj = {}),
          (_obj["has-warning"] = _vm.is_limiting_tech_year),
          _obj),
          attrs: { title: _vm.tech_year_tooltip }
        },
        [_vm._v(_vm._s(_vm.tech_year))]
      )
    ],
    2
  )
  var _obj
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-32dfd9a5", { render: render, staticRenderFns: staticRenderFns })
  }
}